import styled, { css } from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';
import { definitionLabel, definitionValue } from 'styles/base-classes';

const KPILabelStyle = css`
  ${definitionLabel};
  line-height: 2;
`;

export const Flex = styled.div`
  display: flex;
`;

export const KPIListWrapper = styled.div`
  margin: ${({ theme }) => `${theme.spacing.medium} 0`};
`;

export const KPIList = styled.dl`
  display: flex;
  flex-flow: row wrap;
  margin: ${({ theme }) => `-${theme.spacing.medium}`};
`;

export const KPIWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.medium};
  margin-top: 0;
`;

export const KPILabel = styled.dt`
  ${KPILabelStyle}
`;

export const KPIValue = styled.dd`
  display: inline-flex;
  align-items: baseline;
  ${definitionValue};
  font-size: ${modularScale(3)};
  color: ${({ theme }) => theme.DeepBlue};
`;

export const TrendValue = styled.span<any>`
  ${definitionValue};
  font-size: ${modularScale(-3)};
  color: ${({ theme, hasColor }) =>
    hasColor ? theme[hasColor] : theme.CasperGrey};
  margin-left: ${({ theme }) => theme.spacing.small};
`;
